export default {
  PageName: '线路信息',
  SearchPlaceholder: '搜索专线SN/海缆SN/A端IP/Z端IP/设备名/节点名/线路编号',
  sn: '专线SN',
  hlSn: '海缆SN',
  area: '区域',
  type: '类型',
  provider: '供应商',
  isp	: '运营商',
  netName: '网卡名',
  location: '位置',
  tenancy: '租期(天)',
  buyTime: '购买时间',
  dedicatedLineIp: '专线IP',
  detail: '专线质量统计',
  detailComp: {
    packetLossAvg: '丢包均值',
    delayAvg: '时延均值',
    jitterAvg: '抖动均值',
  },
  ASizeIP: 'A端IP',
  ZSizeIP: 'Z端IP',
  Unknown: ' 未知',
  ASideLocation: 'A端地址',
  ZSideLocation: 'Z端地址',
  ispSN: '线路编号',
  StartingTime: '起租时间',
  LeaseStopTime: '止租时间',
  LineName: '线路名称',
  Bandwidth: '带宽',
  Port: '端口',
}